import { BroadcastIcon } from "@primer/octicons-react"

export const Icons = () => {
    return(
        <div className="flex-1 mx-auto my-20">
            <ul className="">
                <li>
                    <BroadcastIcon size={16} className="text-gray-500 hover:text-blue-600 hover:scale-105"/>
                </li>
                <li>
                    
                </li>
                <li></li>
                <li></li>
            </ul>
        </div>
    )
}